import { render } from "./PrintDocument.vue?vue&type=template&id=456fbfca&scoped=true"
import script from "./PrintDocument.vue?vue&type=script&lang=js"
export * from "./PrintDocument.vue?vue&type=script&lang=js"

import "./PrintDocument.vue?vue&type=style&index=0&id=456fbfca&lang=css"
import "./PrintDocument.vue?vue&type=style&index=1&id=456fbfca&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456fbfca"]])

export default __exports__